import React from "react";
import { ChangePasswordView } from "../../views";
import {
  Auth0Service,
  LocalStorageService,
  UserService,
} from "../../../services";


/**
 * @class ChangePasswordAction
 * @extends {React.Component}
 * @status no delete
 * @description class that defines the functionalities for changing the password
 */
class ChangePasswordAction extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  state = {
    userId: "",
    clientId: "",
    userTypeId: "",
    languageId: "",
    email: "",

    password: "",
    confirmPassword: "",

    changePasswordShowPasswordIcon:
      "changePasswordView-show-password-icon-desactive",
    changePasswordShowPasswordConfirmIcon:
      "changePasswordView-show-password-icon-desactive",
    errorForm: false,
    errorMessage: "",

    showLoadingRequesting: false,
    showCompletedRequesting: false,
    showErrorRequesting: false,
  };

  token = {};
  user = {};
  location = {};
  url = process.env.REACT_APP_ETICKET_API;
  localStorageService = new LocalStorageService();
  auth0Service = new Auth0Service();
  userService = new UserService(this.url);

  async componentDidMount() {
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    this.location = this.localStorageService.getLocalStorageItem("url");
    let userInformation = this.user.userMetaData.userA3Cloud;


    this.setState({
      userId: userInformation.id,
      userTypeId: userInformation.userTypeId,
      languageId: userInformation.languageId,
      clientId: userInformation.clientId,
      email: userInformation.email,
    });
  }

  /**
   * @author Alan Aguilar
   * @description Method to show the loading dialog modal
   * @date 15-12-2020
   * @status no delete
   * @memberof RegisterUserInvitedAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the complete request dialog modal
   * @date 15-12-2020
   * @status no delete
   * @memberof RegisterUserInvitedAction
   */
  toggleCompletedRequesting = (value) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false });
          if (this.props.goToChangePasswordScreen) {
            this.props.goToChangePasswordScreen();
          } else if (this.props.redirectToChangePass) {
            window.location.href = this.location;
            window.location.reload();
          } else {
            window.location.reload();
          }
        }, 1000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the Error request dialog modal
   * @date 15-12-2020
   * @status no delete
   * @memberof RegisterUserInvitedAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 4000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the label error
   * @date 15-12-2020
   * @status no delete
   * @memberof AuthService
   */
  onHandleHideError = () => {
    this.setState({
      errorForm: false,
      errorMessage: "",
    });
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the password icon and text in Change Password form
   * @date 15-12-2020
   * @status no delete
   * @memberof AuthService
   */
  onHandleShowPassword = () => {
    let { changePasswordShowPasswordIcon } = this.state;
    let inputPassword = document.querySelector("#password");

    if (
      changePasswordShowPasswordIcon ===
      "changePasswordView-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        changePasswordShowPasswordIcon:
          "changePasswordAction-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        changePasswordShowPasswordIcon:
          "changePasswordView-show-password-icon-desactive",
      });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the confirmPassword icon and text in Change Password form
   * @date 15-12-2020
   * @status no delete
   * @memberof AuthService
   */
  onHandleShowPasswordConfirm = () => {
    let { changePasswordShowPasswordConfirmIcon } = this.state;
    let inputPassword = document.querySelector("#confirmPassword");

    if (
      changePasswordShowPasswordConfirmIcon ===
      "changePasswordView-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        changePasswordShowPasswordConfirmIcon:
          "changePasswordAction-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        changePasswordShowPasswordConfirmIcon:
          "changePasswordView-show-password-icon-desactive",
      });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for capture the information in all inputs
   * @date 15-12-2020
   * @status no delete
   * @param {Object} e
   * @memberof AuthService
   */
  onHandleGeneralChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to change the user password in the register invited
   * @date 15-12-2020
   * @status no delete
   * @memberof RegisterUserInvitedAction
   */
  onSubmitChangeUserPassword = async () => {
    let { password, confirmPassword } = this.state;

    let passwordValue = password.trim();
    let confirmPasswordValue = confirmPassword.trim();

    // Validate that both passwors are equal
    if (!(passwordValue === confirmPasswordValue)) {
      this.setState(
        {
          errorForm: true,
          errorMessage: "Las contraseñas proporcionadas no son iguales",
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 5000);
        }
      );
      return false;
    }

    // Validate if the passwords has more that 8 letters
    if (passwordValue.length < 8 || confirmPasswordValue.length < 8) {
      this.setState(
        {
          errorForm: true,
          errorMessage:
            "La contraseña proporcionada no es mayor de 8 caracteres",
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 5000);
        }
      );
      return false;
    }

    try {
      await this.toggleLoadingRequesting(true);
      // Calling service to change password
      let changePassword = await this.auth0Service.changePasswordRequest(
        confirmPasswordValue,
        this.token
      );
      if (!(Number(changePassword.data.statusCode) === 200))
        throw new Error("No se pudo cambiar la contraseña del usuario");

      await this.toggleLoadingRequesting(false);
      await this.toggleCompletedRequesting(true);
    } catch (error) {
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(true);
      return false;
    }
  };

  render() {
    return (
      <ChangePasswordView
        {...this.state}
        onSubmitChangeUserPassword={this.onSubmitChangeUserPassword}
        onHandleGeneralChange={this.onHandleGeneralChange}
        goToChangePasswordScreen={this.props.goToChangePasswordScreen}
        onHandleShowPassword={this.onHandleShowPassword}
        onHandleShowPasswordConfirm={this.onHandleShowPasswordConfirm}
        onHandleHideError={this.onHandleHideError}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
      />
    );
  }
}
export { ChangePasswordAction as default };
